/** Admissions owns the words for its register, visits and receipts. */
export const admissionsCopy = {
  title: "Admissions", register: "Applicant register", move: "Move to stage",
  contact: "Contact", standing: "Application standing", convert: "Convert to student",
  identity: "Managed account identity", readiness: "Participation readiness",
  documents: "Application documents", submitted: "Submitted details", message: "Message from the application",
  confirmation: "Application confirmation", note: "Internal note", remove: "Remove applicant record",
  empty: "No applications yet. Applications appear here when an intake receives its first file.",
  noMatches: "No matching applicants. Clear a filter to widen the register.",
  unknown: "The result is not confirmed. Check what was recorded before sending anything again.",
  check: "Check", checkNote: "Read the recorded outcome without sending again.",
  noCommit: "This change was not recorded. Review the draft before sending it again.",
  noteScope: "Admin only.",
  convertEffect: "Create a student record and issue its student identifier. This does not invite the person or enroll them in a course.",
  removeEffect: "Delete this application and its documents. An existing invitation remains, without its applicant link.",
  convertedRemoval: "This application is the source of an issued student identifier and cannot be removed.",
  convertedStanding: "The stage and program stay recorded after conversion to a student.",
  identityScope: "Type the exact managed account to create. The application contact remains the delivery and recovery address.",
  confirmationAccepted: "The mail service accepted the application confirmation. Inbox delivery and reading are not proven.",
  confirmationFailed: "The application confirmation was not sent. Review the recorded delivery reason before retrying.",
  confirmationUnknown: "The confirmation may have been sent. Check its delivery record before sending anything again.",
  noMessage: "No message was submitted.", noDetails: "No additional details were submitted.",
  documentStatuses: { pending: "Pending", received: "Received", waived: "Waived" },
  confirmationStates: { pending: "Waiting to send", sending: "Sending", sent: "Accepted for sending", failed: "Not sent", not_configured: "Mail setup unavailable", unknown: "Not confirmed" },
  figures: { applicants: "applicants", review: "in review", admitted: "admitted", incomplete: "files incomplete" },
  savedNote: "Internal note saved.", savedStanding: "Application standing recorded.", removed: "The applicant record was removed.",
  conflict: "This application changed after this draft began. Compare the current record before saving.",
  includes: (name: string, stage: string) => `${name}: move to ${stage}.`,
  leftOut: (name: string, why: string) => `${name}: ${why}.`,
  open: "Open",
  applicant: "Applicant",
  keepMine: "Keep my draft",
  loadNewer: "Load newer record",
  chooseDraft: "Choose which draft to keep.",
  notConfirmed: "Not confirmed",
  notRecorded: "Not recorded",
  removalAttempt: "Removal attempt",
  removeAct: "Remove applicant",
  checkRemoval: "Check this removal first",
  thisApplication: "This application",
  currentReadUnavailable: "Current record unavailable",
  applicantUnavailable: "This application is no longer available to read.",
  draftWord: "Draft",
  recordedWord: "Recorded",
  stageLabel: "Stage",
  applicationStage: "Application stage",
  currentStage: "Current stage",
  decisionRecorded: "Decision recorded",
  recordStanding: "Record standing",
  whenStanding: "When you record this standing",
  personRecord: "Person record",
  updateStanding: "Update standing",
  studentCreated: "Student record created",
  notConverted: "Not converted",
  cohort: "Cohort placement",
  noCohort: "No cohort placement",
  cohortsFailed: "Active cohorts could not be read.",
  tryAgain: "Try again",
  whenConvert: "When you convert this application",
  alreadyStudent: "A student record has already been created.",
  admitFirst: "Record Admitted before creating the student record.",
  readCohorts: "Read the active cohort choices before converting.",
  convertForReadiness: "Convert this admitted application to read student standing and participation.",
  participation: "Participation",
  noNote: "No internal note",
  saveNote: "Save note",
  whenNote: "When you save this note",
  noteEffect: "Save this note for administrators.",
  editNote: "Edit note",
  noteDraft: "Note draft",
  noteRecorded: "Note recorded",
  noNoteYet: "No note yet",
  delivery: "Delivery",
  applicationContact: "Application contact",
  sendConfirmation: "Send confirmation",
  whenConfirmation: "When you send this confirmation",
  confirmationEffect: "Send this application confirmation to the recorded application contact.",
  mailAlreadyAccepted: "The mail service already accepted this confirmation.",
  retained: "Retained",
  removalSelected: "Removal selected",
  applicantRecord: "Applicant record",
  removeLabel: "Remove this application",
  currentRecord: "Current record",
  identifierIssued: "Student identifier issued",
  applicationRetained: "Application retained",
  whenRemove: "When you remove this application",
  confirmRemove: "Confirm removal of this application.",
  identityPrepare: "Prepare the exact login identity",
  givenName: "Given name",
  familyName: "Family name",
  managedAccount: "Managed account",
  studentRecord: "Student record",
  created: "Created",
  inviteStudent: "Invite student",
  whenInvite: "When you invite this student",
  identityEffect: "Create the typed managed account and send an invitation to the application contact.",
  noDocuments: "No documents are requested for this application.",
  documentChanged: "This document changed after your read.",
  currentStatus: "Current status",
  keepStatus: "Keep my status",
  loadStatus: "Load newer status",
  applications: "Applications",
  unnamedProgram: "Unnamed program",
  searchApplicants: "Search applicants",
  allStages: "All stages",
  program: "Program",
  allPrograms: "All programs",
  sort: "Sort",
  newestApplications: "Newest applications",
  applicantName: "Applicant name",
  stageOrder: "Stage order",
  chooseStage: "Choose a stage",
  chooseStageReason: "Choose a stage.",
  stageForSelected: "Stage to move the selected applicants to",
  included: "Included",
  applicationsToMove: "Applications to move",
  whenMove: "When you move these applications",
  selectApplicant: "Select at least one application that can move.",
  retryFailed: "Retry failed applicants",
  retryFailedNote: "Only the failed applicants are sent again, with the original stage and versions.",
  alreadyTarget: "already at this stage",
  alreadyConverted: "student record already created",
  studentCreatedResult: (sid: string) => `Student record created. Student identifier ${sid}.`,
  stageEffect: (stage: string) => `Record ${stage} and who made the decision.`,
  nextAdmitted: (name: string) => `Next admitted: ${name}`,
  decisionBy: (name: string | null) => name ? `Decision recorded by ${name}` : "Decision recorded",
  select: (name: string) => `Select ${name}`,
  selected: (count: number) => `${count} selected`,
  selectCap: (cap: number) => `Select up to ${cap} applications at a time.`,
  moveEffect: (stage: string, count: number) => `Record ${stage || "the chosen stage"} for ${count} applications, with who moved them and when.`,
  applicantFacts: (program: string | null, date: string, docs: number, complete: boolean) => `${program ?? "Program not chosen"} · ${date} · ${docs} documents${complete ? ", complete" : ""}`,
  readFailed: (label: string) => `${label} could not be read.`,
  staleRead: (label: string) => `${label} could not be refreshed. A later change may be missing.`,
  notProvided: "Not provided",
  notRecordedValue: "Not recorded",
  noApplicantSource: "No applicant source",
  admissionStep: "Admission",
  standingStep: "Student standing",
  cohortStep: "Cohort placement",
  invitationStep: "Invitation",
  accountStep: "Account access",
  coursesStep: "Course participation",
  unassigned: "Unassigned",
  cohortNoun: "Cohort",
  archived: "archived",
  notInvited: "Not invited",
  setupFailed: "Provisioning failed",
  setupMailFailed: "Setup email not delivered",
  mailUnavailable: "Mail setup unavailable",
  expired: "Expired",
  reviewStanding: "Review student standing",
  reviewPlacement: "Review placement",
  openInvitation: "Open invitation",
  accountActive: "Active",
  membershipInactive: "Membership inactive",
  notActivated: "Not activated",
  reviewAccess: "Review account access",
  standingNotRecorded: "Standing not recorded",
  contactFields: { email: "Email", phone: "Phone", submittedBy: "Submitted by" },
  submittedByLabels: { parent: "Parent or guardian", student: "The student" },
  intakeLabels: { date_of_birth: "Date of birth", school_name: "School / college / university", grade_level: "Grade / year / semester", major: "Major", mother_name: "Mother’s full name", mother_phone: "Mother’s phone", mother_address: "Mother’s address", father_name: "Father’s full name", father_phone: "Father’s phone", father_address: "Father’s address" },
  invitationStates: { provisioning: "Provisioning", issued: "Issued", claiming: "Activation in progress", accepted: "Accepted", revoked: "Revoked", superseded: "Replaced" },
  studentStates: { active: "Current", leave_of_absence: "On leave", withdrawn: "Withdrawn", completed: "Completed" } as Record<string, string>,
  enrollmentsCount: (count: number) => `${count} active enrollment${count === 1 ? "" : "s"}`,
  visibleCoursesCount: (count: number) => `${count} learner-visible course${count === 1 ? "" : "s"}`,
};
